<template>
  <Activate :invite="invite"
            :loader="loader"
            :disableForm="disableForm"></Activate>
</template>

<script>
  import Activate from '@/views/onboarding/Activate.vue'

  export default{
    name: "Invitation",
    components: {Activate},
    computed: {
      invite() {
        return window.location.search.slice(1)
      }
    },
    data () {
      return {
        disableForm: false,
        loader: false
      }
    },
    created () {
      this.$store.dispatch('resource/deleteDefaultResource');
      if (this.invite) {
        this.loader = true;
        this.postData(`partners/invite/confirmation/${this.invite}`, {}, null, false, true)
            .then(async resp => {
              if (resp) {
                await this.$store.dispatch('auth/saveToken', {token: resp.data.token});
                await this.$store.dispatch('auth/updateUser', {user: resp.data});
                await this.$store.dispatch('auth/fetchUser')
                await this.$store.dispatch('resource/fetchResources');
                await this.$router.push({name: 'Home'});
                await this.$store.dispatch('resource/setDefaultResource');
                this.disableForm = true;
              }
            }).catch((error) => {
              console.log('ERROR:', error);
              this.$router.push({name: 'Login'});
            }).finally(() => {
              this.loader = false;
            });
      } else {
        this.$router.replace({name: '404'})
      }
    }
  }
</script>w